
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 .574a11.38 11.38 0 016.112 1.77c4.75 3.011 5.1 9.23 1.315 13.777-2.16 2.594-4.537 5-7.106 7.19a.5.5 0 01-.642 0 59.298 59.298 0 01-7.106-7.189C.79 11.574 1.138 5.355 5.888 2.344A11.38 11.38 0 0112 .574v0z","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.433 7.184A1.379 1.379 0 0118.5 8.512a1.365 1.365 0 01-.637 1.182l-7.852 4.876a.481.481 0 01-.532-.016L6.6 12.534a.267.267 0 010-.42l1.208-1.064a.266.266 0 01.26-.05l1.514.9 1.92-1.34-3.639-2.245A.331.331 0 017.88 7.8l.89-.66a.332.332 0 01.312-.044L14.1 8.962l2.32-1.583a1.285 1.285 0 011.013-.195z","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    